var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  API_URL: '"https://stageinvestigationapi.xbees.in/api/"',
  AWS_BUCKET: '"xbeestest"',
  FORGOT_PASSWORD: '"https://stageusermanagement.xbees.in/#/forgotpassword"',
  Image_URL: '"https://xbeestest.s3.amazonaws.com/"',
  Dispute_Bucket : '"xbeestest"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 383
// module chunks = 1